import { Alert, Snackbar, Typography } from '@mui/material';
import type { SnackbarCloseReason } from '@mui/material';

import type { Feedback } from '../../lib/useFeedback';

export interface FeedbackSnackbarProps {
  feedback: Feedback | null;
  onClose: () => void;
  autoHideDuration?: number;
}

/** Renders transient success/error feedback for a settings screen. */
export function FeedbackSnackbar({
  feedback,
  onClose,
  autoHideDuration = 5000,
}: FeedbackSnackbarProps) {
  const handleClose = (_event: unknown, reason?: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose();
  };

  return (
    <Snackbar
      open={feedback !== null}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={() => onClose()}
        severity={feedback?.severity ?? 'info'}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {feedback?.message ?? ''}
        {feedback?.hint ? (
          <Typography
            variant="caption"
            sx={{ display: 'block', mt: 0.5, opacity: 0.85 }}
          >
            {feedback.hint}
          </Typography>
        ) : null}
      </Alert>
    </Snackbar>
  );
}
